var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_33",
    "data-name": "Group 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46.715,
    height: 43.938,
    viewBox: "0 0 46.715 43.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 46.715,
    height: 43.938,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M40.517,0H6.2A6.2,6.2,0,0,0,0,6.2v31.54a6.2,6.2,0,0,0,6.2,6.2H40.517a6.2,6.2,0,0,0,6.2-6.2V6.2a6.2,6.2,0,0,0-6.2-6.2",
    transform: "translate(0 0)",
    fill: "#2a77eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M9.985,25.271a11.253,11.253,0,0,0,.787.852A14.046,14.046,0,0,0,19.3,29.849q.192.016.385.028.409.023.82.024a14.14,14.14,0,0,0,3.774-.471.39.39,0,0,0-.073-.765,13.044,13.044,0,0,1-10.574-7.457,2.685,2.685,0,0,0-3.1-1.483,2.636,2.636,0,0,0-1.685,3.639A7,7,0,0,0,9.686,24.9c.1.127.2.252.3.375",
    transform: "translate(-2.767 -6.304)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M48.812,10.207a2.644,2.644,0,0,0-3.3-2.291,2.8,2.8,0,0,0-1.954,2.83c0,10.984-10.175,15.9-13.545,16.779a15.437,15.437,0,0,1-4.313.539h-.046a.635.635,0,0,0-.2,1.243,18.295,18.295,0,0,0,23.358-19.1",
    transform: "translate(-8.027 -2.513)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M10.724,48.119a.871.871,0,0,0-.733.367,1.473,1.473,0,0,0-.244.917v2.323H8.585V45.857h.55a.548.548,0,0,1,.612.611v1.345a1.8,1.8,0,0,1,2.139-.55q.918.367.917,1.833v2.628H11.641V49.4a1.268,1.268,0,0,0-.244-.917.7.7,0,0,0-.672-.367",
    transform: "translate(-2.756 -14.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M19.461,50.986a1.8,1.8,0,0,1-.672,1.1,2.324,2.324,0,0,1-1.344.367q-2.018-.092-2.017-2.384c0-1.528.672-2.323,2.078-2.323,1.467,0,2.139.917,2.017,2.689H16.588c.061.673.367,1.04.917,1.04a1.27,1.27,0,0,0,.733-.306.529.529,0,0,1,.367-.184Zm-1.1-1.405c-.061-.611-.367-.917-.856-.917s-.8.306-.856.917Z",
    transform: "translate(-4.952 -15.327)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M22.61,45.857a.436.436,0,0,1,.367.183.528.528,0,0,1,.183.367v5.318H22V45.857Z",
    transform: "translate(-7.062 -14.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M25.04,45.857a.436.436,0,0,1,.367.183.528.528,0,0,1,.183.367v5.318H24.429V45.857Z",
    transform: "translate(-7.842 -14.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M30.926,50.131c0,1.59-.672,2.384-2.078,2.384s-2.078-.794-2.078-2.384.672-2.384,2.078-2.384,2.078.794,2.078,2.384m-2.995,0c0,.917.306,1.344.917,1.344s.856-.428.917-1.344c0-.917-.306-1.344-.856-1.344-.672-.061-.978.428-.978,1.344",
    transform: "translate(-8.594 -15.327)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M38.275,50.959a1.708,1.708,0,0,1-.672,1.1,1.876,1.876,0,0,1-1.284.367c-1.405,0-2.078-.8-2.139-2.384,0-1.589.672-2.384,2.078-2.384a1.743,1.743,0,0,1,1.956,1.467H36.992a.738.738,0,0,0-.734-.489c-.611,0-.917.428-.917,1.345s.306,1.344.978,1.344a.983.983,0,0,0,.673-.306.528.528,0,0,1,.367-.183h.917Z",
    transform: "translate(-10.972 -15.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M45,50.131c0,1.59-.672,2.384-2.078,2.384s-2.078-.794-2.078-2.384.672-2.384,2.078-2.384S45,48.541,45,50.131m-2.995,0c0,.917.306,1.344.917,1.344s.856-.428.917-1.344c0-.917-.306-1.344-.856-1.344-.672,0-.978.428-.978,1.344",
    transform: "translate(-13.111 -15.327)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M51.17,45.947a.627.627,0,0,1,.611.611v3.3a1.823,1.823,0,0,1-2.139,2.017c-1.405,0-2.139-.794-2.139-2.323s.611-2.322,1.834-2.383a1.436,1.436,0,0,1,1.283.733V45.947Zm-1.528,2.262c-.611,0-.917.428-.978,1.344,0,.917.306,1.406.978,1.406s.978-.489.978-1.406c-.061-.917-.367-1.344-.978-1.344",
    transform: "translate(-15.249 -14.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M58.259,50.986a1.8,1.8,0,0,1-.672,1.1,2.324,2.324,0,0,1-1.344.367c-1.406-.061-2.078-.856-2.078-2.384s.672-2.323,2.078-2.323c1.467,0,2.139.917,2.017,2.689H55.325c.061.673.367,1.04.917,1.04a1.27,1.27,0,0,0,.733-.306.527.527,0,0,1,.367-.184ZM57.1,49.642c-.061-.611-.367-.917-.856-.917s-.8.306-.856.917Z",
    transform: "translate(-17.388 -15.327)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLogo);
export default __webpack_public_path__ + "static/media/blue_logo.e69a0b0185360bc94b7cb13655c1841a.svg";
export { ForwardRef as ReactComponent };